import React from "react";
import styled from "styled-components";
import EyesSVG from "../../assets/svg/eyes.inline.svg";

const Holder = styled.footer`
  position: relative;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: transparent;
  height: 75px;
  margin-top: -75px;

  @media (${(props) => props.theme.breakpoints.md}) {
    padding: 20px 39px 28px 28px;
  }

  p {
    margin: 0;
  }

  .attribution {
    font-size: 14px;
    font-weight: 300;
  }
`;

const Eyes = styled.div`
  a {
    display: block;

    svg {
      width: auto;
      height: 24px;
      display: block;
      @media (${(props) => props.theme.breakpoints.md}) {
        width: 77px;
        height: auto;
      }
    }
  }
`;

function Footer() {
  return (
    <Holder>
      <Eyes>
        <a
          className="eyes"
          href="https://www.instagram.com/studiolibro/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <EyesSVG />
        </a>
      </Eyes>
      <p className="attribution">
        &copy; Studio Libro {new Date().getFullYear()}
      </p>
    </Holder>
  );
}

export default Footer;
